import { createApp } from 'vue';
import Notifications from '@kyvg/vue3-notification';
import OpenLayersMap from "vue3-openlayers";
import "vue3-openlayers/dist/vue3-openlayers.css";

import App from './App.vue';
import router from './router'
import { store, static_store } from './store';
import { PluginManager, pluginRegistry, loadInstalledPlugins } from './plugins';
import { bindUserId } from './utils/analytics';


const app = createApp(App);
app.use(router)
app.use(OpenLayersMap)
app.use(Notifications);

const pluginManager = new PluginManager(app, router, store, static_store);
app.provide('pluginManager', pluginManager);
app.provide('pluginRegistry', pluginRegistry);

// GA user_id follows the signed-in account (src/utils/analytics.js).
bindUserId(store)

loadInstalledPlugins(pluginManager).then(() => {
  app.mount('#app');
});
